export const complicationList = [
    { value: 0, text:'Nil' },
    { value: 1, text:'Perforation'},
    { value: 2, text:'Significant Bleeding' },
    { value: 3, text:'Cardiopulmonary Complication'}
]

export const indicationList = [
    { value: 1, text: '國健局糞便潛血檢查陽性' },
    { value: 2, text: '自費健康檢查'},
    { value: 3, text: '大腸癌家族史' },
    { value: 4, text: '息肉切除後追蹤'},
    { value: 5, text: '大腸癌術後追蹤' },
    { value: 6, text: '大腸鏡併發症相關處理'},
    { value: 7, text: '其他臨床目的施行之大腸鏡' }
]
export const preparationTimeList = [
    '',
    'Morning single dose',
    'Evening single dose',
    'Split dose'
]

export const noUseAntipasmodicReasonList = [
    { value: 1, text: 'Glaucoma' },
    { value: 2, text: 'BPH'}
]

export const cleanScaleList = [
    { value: '0', text: '' }, 
    { value: '1', text: 'Poor' }, 
    { value: '2', text: 'Fair' }, 
    { value: '3', text: 'Good' }, 
    { value: '4', text: 'Excellent' }
]

export const gastroPreparationList = [
    { value: '0', text: '' }, 
    { value: '1', text: 'food debris' }, 
    { value: '2', text: 'food stasis' }, 
    { value: '3', text: 'food' },
    { value: '4', text: 'redundant' }, 
    { value: '5', text: 'adhesion' },
    { value: '6', text: 'much gas' },
    { value: '7', text: 'gastric acid' },
]

export const colonPreparationList = [
    { value: '0', text: '' }, 
    { value: '1', text: 'stool' }, 
    { value: '2', text: 'stool impaction' }, 
    { value: '3', text: 'stool stasis' },
    { value: '4', text: 'redundant' }, 
    { value: '5', text: 'adhesion' }
]

export const insertionLevelList = [
    { value: '0', text: '' }, 
    { value: '1', text: 'Terminal ileum' },
    { value: '2', text: 'Ileocecal valve' },
    { value: '3', text: 'Appendix orifice' },
    { value: '4', text: 'Cecum' },
    { value: '5', text: 'Ascending colon' },
    { value: '6', text: 'Proximal Ascending Colon' },
    { value: '7', text: 'Middle Ascending Colon' },
    { value: '8', text: 'Distal Ascending Colon' },
    { value: '9', text: 'Hepatic flexure' },
    { value: '10', text: 'Transverse colon' },
    { value: '11', text: 'Proximal Transverse colon' },
    { value: '12', text: 'Middle Transverse colon' },
    { value: '13', text: 'Distal Transverse colon' },
    { value: '14', text: 'Splenic flexure' },
    { value: '15', text: 'Descending colon' },
    { value: '16', text: 'Proximal Descending Colon' },
    { value: '17', text: 'Middle Descending Colon' },
    { value: '18', text: 'Distal Descending Colon' },
    { value: '19', text: 'Sigmoid colon' },
    { value: '20', text: 'Proximal Sigmoid Colon' },
    { value: '21', text: 'Middle Sigmoid Colon' },
    { value: '22', text: 'Distal Sigmoid Colon' },
    { value: '23', text: 'RS junction' },
    { value: '24', text: 'Rectum' },
    { value: '25', text: 'Upper Rectum' },
    { value: '26', text: 'Middle Rectum' },
    { value: '27', text: 'Lower Rectum' },
    { value: '28', text: 'Anus' },
    { value: '29', text: 'All segments of colon' },
    { value: '30', text: 'Anastomosis' }
]

export const colonIncompleteReasonList = [
    { value: '0', text: '' }, 
    { value: '1', text: 'Poor Preparation' }, 
    { value: '2', text: 'Bleeding' }, 
    { value: '3', text: 'Bowel Perforation' }, 
    { value: '4', text: 'Patient Intolerance' }, 
    { value: '5', text: 'Other' },
    { value: '6', text: 'Food Stasis' },
    { value: '7', text: 'Undigested Medicine' },
]

export const gastroIncompleteReasonList = [
    { value: '0', text:'' },
    { value: '1', text:'intolerance' },
    { value: '2', text:'bleeding'},
    { value: '3', text: 'food stasis' },
    { value: '4', text: 'undigested medicine' },
]